import React, { useState } from "react";
import { Text, StyleSheet, TouchableOpacity, Button } from "react-native";
import { Input } from "react-native-elements";

const AddScreen = () => {
  const [noOfDigits, setNoOfDigits] = useState("");
  const [frequency, setFrequency] = useState("");
  const [time, setTime] = useState("");
  const [display, setDisplay] = useState();
  const [hide, setHide] = useState(false);
  const [hide2, setHide2] = useState(false);
  const [userAnswer, setUserAnswer] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [hide3, setHide3] = useState(false);
  const [sumNumber, setSumNumber] = useState("");
  const [lavesh, setLavesh] = useState("");

  const onChangeUtil = () => {
    if (noOfDigits.length == 0 || frequency.length == 0 || time.length == 0) {
      alert("Please Enter The Field Properly");
    } else {
      onChange();
    }
  };

  const onStartAgain = () => {
    setHide(true);
    setHide2(false);
    setHide3(false);
    setUserAnswer("");
    setLavesh("(number)");
    var count = frequency;
    var ans = 0;
    var c = 1;
    if (count > 0) {
      var number =
        "" +
        Math.floor(
          Math.random() *
            (Math.pow(10, noOfDigits) - Math.pow(10, noOfDigits - 1)) +
            Math.pow(10, noOfDigits - 1)
        ) +
        "";
      ans = ans + parseInt(number);
      setSumNumber(c);
      c++;
      setDisplay(number);
      count--;
    }
    var myVar = setInterval(() => {
      if (count > 0) {
        var number =
          "" +
          Math.floor(
            Math.random() *
              (Math.pow(10, noOfDigits) - Math.pow(10, noOfDigits - 1)) +
              Math.pow(10, noOfDigits - 1)
          ) +
          "";
        ans = ans + parseInt(number);
        setSumNumber(c);
        c++;
        setDisplay(number);
        count--;
      } else {
        setDisplay("");
        clearInterval(myVar);
        setHide2(true);
        setSumNumber("");
        setLavesh("");
        setCorrectAnswer(ans);
      }
    }, parseInt(time * 1000));
  };
  const onChange = () => {
    setHide(true);
    var count = frequency;
    var ans = 0;
    var c = 1;
    setLavesh("(number)");
    if (count > 0) {
      var number =
        "" +
        Math.floor(
          Math.random() *
            (Math.pow(10, noOfDigits) - Math.pow(10, noOfDigits - 1)) +
            Math.pow(10, noOfDigits - 1)
        ) +
        "";
      ans = ans + parseInt(number);
      setSumNumber(c);
      c++;
      setDisplay(number);
      count--;
    }
    var myVar = setInterval(() => {
      if (count > 0) {
        var number =
          "" +
          Math.floor(
            Math.random() *
              (Math.pow(10, noOfDigits) - Math.pow(10, noOfDigits - 1)) +
              Math.pow(10, noOfDigits - 1)
          ) +
          "";
        ans = ans + parseInt(number);
        setSumNumber(c);
        c++;
        setDisplay(number);
        count--;
      } else {
        setDisplay("");
        clearInterval(myVar);
        setHide2(true);
        setLavesh("");
        setSumNumber("");
        setCorrectAnswer(ans);
      }
    }, parseInt(time * 1000));
  };

  const goBack = () => {
    setHide(false);
    setHide2(false);
    setHide3(false);
  };
  const checkAnswer = () => {
    setHide3(true);
    //alert(`correct answer is ${correctAnswer}`);
  };

  return (
    <>
      {!hide && (
        <>
          <Input
            keyboardType={"number-pad"}
            label="Digits"
            value={noOfDigits}
            onChangeText={(newValue) => setNoOfDigits(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <Input
            keyboardType={"number-pad"}
            label="Number of Sums"
            value={frequency}
            onChangeText={(newValue) => setFrequency(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <Input
            keyboardType={"number-pad"}
            label="Time in Second"
            value={time}
            onChangeText={(newValue) => setTime(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <TouchableOpacity style={styles.button} onPress={onChangeUtil}>
            <Text>Start</Text>
          </TouchableOpacity>
        </>
      )}
      <Text style={styles.text}>{display}</Text>
      <Text style={styles.text}>
        {sumNumber}
        {lavesh}
      </Text>
      {hide2 && (
        <>
          <Input
            keyboardType={"number-pad"}
            label="Enter Your answer"
            value={userAnswer}
            onChangeText={(newValue) => setUserAnswer(newValue)}
          />

          <TouchableOpacity onPress={() => checkAnswer()} style={styles.button}>
            <Text>Check Answer</Text>
          </TouchableOpacity>
          {hide3 && (
            <>
              <Text style={styles.text}>{correctAnswer}</Text>
            </>
          )}
          <TouchableOpacity onPress={onStartAgain} style={styles.button}>
            <Text>Start Again</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={goBack} style={styles.button}>
            <Text>Go Back To Addition Screen</Text>
          </TouchableOpacity>
        </>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  input: {
    margin: 10,
  },
  button: {
    alignItems: "center",
    borderColor: "black",
    borderWidth: 2,
    borderRadius: 180,
    padding: 10,
    margin: 10,
  },
  btn: {
    margin: 10,
    padding: 10,
  },
  text: {
    fontSize: 50,
    textAlign: "center",
  },
  textDanger: {
    textAlign: "center",
    fontSize: 30,
    color: "red",
    fontWeight: "bold",
  },
  buttonDanger: {
    alignItems: "center",
    borderColor: "red",
    borderWidth: 5,
    borderRadius: 180,
    padding: 10,
    margin: 10,
  },
});

export default AddScreen;
